import api from '../../api';
// 新增文章
export function addnews(params) {
  return api.post('/news/addNews.go', params).then(res => res);
}
// 新增文章
export function getNewsList(params) {
  return api.post('/news/getNewsList.go', params, false, false).then(res => res);
}
// 获取文章详情
export function getNews(params) {
  return api.post('/news/getNews.go', params, false, false).then(res => res);
}
// 更新文章
export function upnews(params) {
  return api.post('/news/upNews.go', params).then(res => res);
}
// 删除文章
export function delnew(params) {
  return api.post('/news/delNews.go', params).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/news.js